export const MEMBER_DEFINITIONS = "/Member/GetMembers"
export const MEMBER_INSERT = "/Member/InsertMember"
export const MEMBER_UPDATE = "/Member/UpdateMember"
export const MEMBER_DELETE = "/Member/DeleteMember"